<template>
    <div>
        <ob-folder :expand.sync="ExpandFolder">
            <template slot="header">
                <template v-if="empDetails">
                    <div class="col-sm-8" style="padding-left:0;">
                        <h4 class="folder-header-heading header-text" :title="empDetails.JobName">{{empDetails.JobName}}</h4>
                        <span v-if="empDetails.WorkAuthorizationType !='' && empDetails.WorkAuthorizationType !=null" class="Work-auth-tax">
                            {{empDetails.WorkAuthorizationType}}
                        </span>
                       <p class="folder-header-sub-heading">
                        <span v-if="empDetails.EndClientName">End Client Name: {{ empDetails.EndClientName }}</span>
                        <span v-else>End Client Name: N/A</span>
                        <template v-if="!empDetails.EndDate || empDetails.EndDate === '0001/01/01T00:00:00'">
                            <span>| Project Ends in : No Expiration</span>
                        </template>
                        <template v-else>
                            <span v-if="EndDateCount >= 0">| Project Ends in :</span>
                            <span v-else>| Project End Date :</span>
                            <span class="projects-days" v-if="EndDateCount >= 0">{{ EndDateCountFormate(empDetails.EndDate) }}</span>
                            <span class="projects-days" v-else>{{ empDetails.EndDate }}</span>
                        </template>
                        </p>
                    </div>
                    <div class="col-sm-2 project-status">
                        <span class="project-status--lebel">Status</span>
                        <!-- bug 158962 -->
                        <span class="project-status--message">{{empDetails.JobStatus == 'YetToStart' ? "Yet to start" : empDetails.JobStatus}}</span>
                    </div>
                    <div class="col-sm-2 project-actions_btn" v-if="empDetails.ProjectCreatedByConsultantId == loggedInUserObj.consultantId">
                        <div>
                                <ob-dropdown title="Action">
                                    <ob-dropdown-list-item @click.native="editProjectInfo(empDetails.JobId)">Update Project</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="alertDeleteProject(empDetails.JobId, empDetails.IsLCALinked)">Delete Project</ob-dropdown-list-item>
                                </ob-dropdown>
                        </div>
                    </div>
                </template>
            </template>
            <template slot="body">
                <div v-if="isOnboarded">
                    <ob-spinner v-if="!empDetails" type="section" loading-text="Loading..." style="height:500px;display:block;position:relative"></ob-spinner>
                    <div v-else>
                        <div class="project-control-documents pT0 pB0" :class="{'editing': empDetails.updateFlag}">
                            <h4  class="sub-heading">Project Information</h4><span class="view-job_details"><a @click="viewJobDetailsShow">View Job details</a></span>
                            <div v-if="!empDetails.updateFlag" width="100%">
                                <div class="row m0 details-show-con">
                                    <!-- <div class="col-md-4 pL0" v-if="!isAccountManager"> -->
                                    <div class="col-md-4 pL0">
                                        <span class="headline">Account Manager</span>
                                        <span class="headline-message" v-if="empDetails.AccountManagerName != null && empDetails.AccountManagerName != ''" :title="empDetails.AccountManagerName">{{empDetails.AccountManagerName}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <!-- <div class="col-md-4" :class ="{'pL0': isAccountManager}"> -->
                                        <div class="col-md-4">
                                        <span class="headline" >End Client Organization Name</span>
                                        <span class="headline-message" v-if="empDetails.EndClientName != null && empDetails.EndClientName != ''" :title="empDetails.EndClientName">{{empDetails.EndClientName}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                </div>
                                <div class="row m0 details-show-con">
                                    <div class="col-md-4 pL0">
                                        <span class="headline">Project Start Date</span>
                                        <span class="headline-message" v-if="empDetails.StartDate != null && empDetails.StartDate != '' && empDetails.StartDate != '0001/01/01T00:00:00'"
                                            :title="empDetails.StartDate">{{empDetails.StartDate}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Project End</span>
                                        <span class="headline-message" v-if="!empDetails.EndDate || empDetails.EndDate === '0001/01/01T00:00:00'"
                                            :title="empDetails.EndDate">No Expiration</span>
                                        <span class="headline-message" v-else-if="empDetails.EndDate != null && empDetails.EndDate != '' && empDetails.EndDate != '0001/01/01T00:00:00'"
                                            :title="empDetails.EndDate">{{empDetails.EndDate}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Duration(Months)</span>
                                        <span class="headline-message" v-if="empDetails.Duration != null" :title="empDetails.Duration">{{empDetails.Duration}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                </div>
                                <div class="row m0 details-show-con">
                                    <div class="col-md-4 pL0">
                                        <span class="headline">Employee start date on this project</span>
                                        <span class="headline-message" v-if="empDetails.EmployementStartDate && empDetails.EmployementStartDate != 'N/A'"
                                            :title="empDetails.EmployementStartDate">{{empDetails.EmployementStartDate}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Employee end date on this project</span>
                                        <span class="headline-message" v-if="!empDetails.EmployementProjectEndDate || empDetails.EmployementProjectEndDate === '0001/01/01T00:00:00' || empDetails.EmployementProjectEndDate === 'N/A'"
                                            :title="empDetails.EmployementProjectEndDate">No Expiration</span>
                                        <span class="headline-message" v-else-if="empDetails.EmployementProjectEndDate && empDetails.EmployementProjectEndDate != 'N/A'"
                                            :title="empDetails.EmployementProjectEndDate">{{empDetails.EmployementProjectEndDate}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                </div>
                                
                                <h4  class="sub-heading">Work Location</h4>
                                <div class="row details-show-con" style="margin-left: -15px;">
                                    <div class="col-md-4" v-for="(Work,index) in empDetails.WorkLocations">
                                        <span style="margin-bottom: 5px;magin-top:15px" class="headline" v-if="index == 0">Work Location (Actual Work Location)</span>
                                        <span style="margin-bottom: 5px;magin-top:15px" class="headline" v-else>Work Location {{index+1}}</span>
                                        <span class="proj-location" :title="getWorkLocation(Work)">
                                         {{getWorkLocation(Work)}}
                                        </span>
                                    </div>
                                </div>
                                            <h4  class="sub-heading">Timesheet Details</h4>
                                  <div class="row m0 details-show-con">
                                    <div class="col-md-4 pL0" v-if="empDetails.TimeSheetCycle == 'Custom'">
                                        <span class="headline">TimeSheet Cycle</span>
                                        <span class="headline-message" v-if="empDetails.TimeSheetSpecifyDate != null && empDetails.TimeSheetSpecifyDate != ''" :title="empDetails.TimeSheetSpecifyDate">{{getDateFormat(empDetails.TimeSheetSpecifyDate)}} of Every Month</span>
                                    </div>
                                    <div class="col-md-4 pL0" v-else>
                                        <span class="headline">TimeSheet Cycle</span>
                                        <span class="headline-message" v-if="empDetails.TimeSheetCycle != null && empDetails.TimeSheetCycle != ''" :title="empDetails.TimeSheetCycle">{{getTimeSheetCycleName(empDetails.TimeSheetCycle)}}</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">OverTime applicable</span>
                                        <span class="headline-message" :title="empDetails.IsOverTimeApplicable">{{empDetails.IsOverTimeApplicable == true ? "Yes" : "No"}}</span>
                                    </div>
                                     <div class="col-md-4">
                                        <span class="headline">Client approved Timesheets</span>
                                        <span class="headline-message" :title="empDetails.IsClientAttachmentsRequired">{{empDetails.IsClientAttachmentsRequired ? "Yes" : "No" }}</span>
                                    </div>
                                </div>
                                <div class="row m0 details-show-con">
                                    <div class="col-md-4 pL0">
                                        <span class="headline">Maximum regular time hours</span>
                                        <span v-if="empDetails.MaximumRegulerTimesheetHours != undefined && empDetails.MaximumRegulerTimesheetHours !=null && empDetails.MaximumRegulerTimesheetHours != 0" class="headline-message" :title="empDetails.MaximumRegulerTimesheetHours">{{empDetails.MaximumRegulerTimesheetHours}}</span><span v-else class="headline-message">N/A</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Third Party Approver Name</span>
                                        <span v-if="empDetails.ThirdPartyTimesheetApprover != null && empDetails.ThirdPartyTimesheetApprover != '' && empDetails.ThirdPartyTimesheetApprover.Name != null && empDetails.ThirdPartyTimesheetApprover.Name != ''" class="headline-message" :title="empDetails.ThirdPartyTimesheetApprover.Name">{{empDetails.ThirdPartyTimesheetApprover.Name}}</span><span v-else class="headline-message">N/A</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Third Party Approver Email</span>
                                        <span v-if="empDetails.ThirdPartyTimesheetApprover != null && empDetails.ThirdPartyTimesheetApprover != '' && empDetails.ThirdPartyTimesheetApprover.Email != null && empDetails.ThirdPartyTimesheetApprover.Email != ''" class="headline-message" :title="empDetails.ThirdPartyTimesheetApprover.Email">{{empDetails.ThirdPartyTimesheetApprover.Email}}</span><span v-else class="headline-message">N/A</span>
                                    </div>
                                </div>
                                 <h4  class="sub-heading">Client/Vendor Information</h4>
                                <div class="row m0 details-show-con">
                                    <div class="col-md-4 pL0">
                                        <span class="headline">Client Organization Name</span>
                                        <span class="headline-message" v-if="empDetails.ClientName != null && empDetails.ClientName != ''" :title="empDetails.ClientName">{{empDetails.ClientName}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <!-- <div class="col-md-4">
                                        <span class="headline">Client Contact Name</span>
                                        <span class="headline-message" v-if="empDetails.CompanySalesManager != null && empDetails.CompanySalesManager != ''" :title="empDetails.CompanySalesManager">{{empDetails.CompanySalesManager}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Client Contact Email</span>
                                        <span class="headline-message" v-if="empDetails.CompanySalesManagerEmail != null && empDetails.CompanySalesManagerEmail != ''"
                                            :title="empDetails.CompanySalesManagerEmail">{{empDetails.CompanySalesManagerEmail}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div> -->
                                </div>
                                 <div class="row m0 details-show-con" v-if="this.empDetails.OnBoardHireType == 'C2C'">
                                    <!-- <div class="col-md-4 pL0">
                                        <span class="headline">Vendor Organization Name</span>
                                        <span class="headline-message" v-if="empDetails.VendorName != null && empDetails.VendorName != ''" :title="empDetails.VendorName">{{empDetails.VendorName}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Vendor Contact Name</span>
                                        <span class="headline-message" v-if="empDetails.VendorContactName != null && empDetails.VendorContactName != ''" :title="empDetails.VendorContactName">{{empDetails.VendorContactName}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Vendor Contact Email</span>
                                        <span class="headline-message" v-if="empDetails.VendorEmail != null && empDetails.VendorEmail != ''" :title="empDetails.VendorEmail">{{empDetails.VendorEmail}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div> -->
                                </div>
                                <!-- <h4  class="sub-heading"> Invoice Information</h4>
                                <div class="row m0 details-show-con">
                                    <div class="col-md-4 pL0">
                                        <span class="headline">Invoicing Contact Name</span>
                                        <span class="headline-message" v-if="empDetails.InvoicingDetailsModel != null && empDetails.InvoicingDetailsModel.ContactName != ''" :title="empDetails.InvoicingDetailsModel.ContactName">{{empDetails.InvoicingDetailsModel.ContactName}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Invoicing Contact Phone Number</span>
                                        <span class="headline-message" v-if="empDetails.InvoicingDetailsModel != null && empDetails.InvoicingDetailsModel.ContactPhoneNumber != ''" :title="empDetails.InvoicingDetailsModel.ContactPhoneNumber">{{empDetails.InvoicingDetailsModel.ContactPhoneNumber}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Invoicing Contact Email ID</span>
                                        <span class="headline-message" v-if="empDetails.InvoicingDetailsModel != null && empDetails.InvoicingDetailsModel.ContactEmailId != ''" :title="empDetails.InvoicingDetailsModel.ContactEmailId">{{empDetails.InvoicingDetailsModel.ContactEmailId}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                </div> -->
                                 <!-- <div class="row m0 details-show-con">
                                    <div class="col-md-4 pL0" v-if="empDetails.TimeSheetCycle == 'Custom'">
                                        <span class="headline">TimeSheet Cycle</span>
                                        <span class="headline-message" v-if="empDetails.TimeSheetSpecifyDate != null && empDetails.TimeSheetSpecifyDate != ''" :title="empDetails.TimeSheetSpecifyDate">{{getDateFormat(empDetails.TimeSheetSpecifyDate)}} of Every Month</span>
                                    </div>
                                    <div class="col-md-4 pL0" v-else>
                                        <span class="headline">TimeSheet Cycle</span>
                                        <span class="headline-message" v-if="empDetails.TimeSheetCycle != null && empDetails.TimeSheetCycle != ''" :title="empDetails.TimeSheetCycle">{{getTimeSheetCycleName(empDetails.TimeSheetCycle)}}</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">OverTime</span>
                                        <span class="headline-message" :title="empDetails.IsOverTimeApplicable">{{empDetails.IsOverTimeApplicable == true ? "Yes" : "No"}}</span>
                                    </div>
                                     <div class="col-md-4"  v-if="empDetails.InvoiceCycle == null || empDetails.InvoiceCycle == '' || empDetails.InvoiceCycle == 'None'">
                                        <span class="headline">Invoice Cycle</span>
                                        <span class="headline-message" :title="empDetails.InvoiceCycle">{{getTimeSheetCycleName(empDetails.InvoiceCycle)}}</span>
                                    </div>

                                </div> -->
                                 <!-- <div class="row m0 details-show-con" v-if="empDetails.InvoiceCycle != null && empDetails.InvoiceCycle != '' && empDetails.InvoiceCycle != 'None'">
                                    <div class="col-md-4 pL0" v-if="empDetails.InvoiceCycle == 'Custom'">
                                        <span  class="headline">Invoice Cycle</span>
                                        <span class="headline-message" v-if="empDetails.InvoiceSpecifyDate != null && empDetails.InvoiceSpecifyDate != ''" :title="empDetails.InvoiceSpecifyDate">{{getDateFormat(empDetails.InvoiceSpecifyDate)}} of Every Month</span>
                                    </div>
                                    <div class="col-md-4 pL0" v-else>
                                        <span class="headline">Invoice Cycle</span>
                                        <span class="headline-message" v-if="empDetails.InvoiceCycle != null && empDetails.InvoiceCycle != ''" :title="empDetails.InvoiceCycle">{{getTimeSheetCycleName(empDetails.InvoiceCycle)}}</span>
                                    </div>
                                    <div class="col-md-4">
                                        <span class="headline">Payment Terms</span>
                                        <span class="headline-message" v-if="empDetails.QBPaymentTerms != null && empDetails.QBPaymentTerms != ''" :title="empDetails.QBPaymentTerms">{{empDetails.QBPaymentTerms}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                </div> -->
                               
                                <div class="row m0 details-show-con details-bottom">
                                    <!-- <div class="col-md-4 pL0">
                                        <span class="headline">Bill Rate</span>
                                        <span class="headline-message" v-if="empDetails.BillRate != null && empDetails.BillRate != ''" :title="empDetails.BillRate">${{empDetails.BillRate}}/hr</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div>
                                    <div class="col-md-4" v-if="this.empDetails.OnBoardHireType == 'C2C'">
                                        <span class="headline">Pay Rate</span>
                                        <span class="headline-message" v-if="empDetails.PayRate != null && empDetails.PayRate != ''" :title="empDetails.PayRate">${{empDetails.PayRate}}/hr</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </div> -->
                                </div>
                                <div class="project-control-documents work-force-con" v-for="(Work,index) in empDetails.WorkLocations" :key='index'>
                                       <h4 class="work-location-header">Work Location {{index+1}}</h4>
                                        <span  class="work-location-data headline-message" v-if="Work.Address2 !=''">{{Work.Address2}} &#44;</span>
                                        <span class="work-location-data headline-message" > {{Work.Address1}}</span>
                                        <span class="work-location-data headline-message" >&#44;{{Work.Location}}</span>
                                        <span class="work-location-data headline-message">&#44; {{Work.Zipcode}}</span>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <!-- <div class="project-control-documents" v-if="(empDetails.SOCWageInformation != null && empDetails.SOCWageInformation != '') && (!isRecruiter) && (empDetails.Taxterms == 'W2') && (h1BFind)"> -->
                        <div class="project-control-documents" v-if="(empDetails.SOCWageInformation != null && empDetails.SOCWageInformation != '') && (empDetails.Taxterms == 'W2') && (h1BFind)">
                            <h4>SOC/Wage Information</h4>

                            <table v-if="!empDetails.updateFlag" width="100%">
                                <tr>
                                    <td>
                                        <span class="headline">Area Code</span>
                                        <span class="headline-message" v-if="empDetails.SOCWageInformation.AreaCode != null && empDetails.SOCWageInformation.AreaCode != ''"
                                            :title="empDetails.SOCWageInformation.AreaCode">{{empDetails.SOCWageInformation.AreaCode}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </td>
                                    <td>
                                        <span class="headline">County/Township</span>
                                        <span class="headline-message" v-if="empDetails.SOCWageInformation.County != null && empDetails.SOCWageInformation.County != ''"
                                            :title="empDetails.SOCWageInformation.County">{{empDetails.SOCWageInformation.County}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </td>
                                    <td>
                                        <span class="headline">OES/SOC Code</span>
                                        <span class="headline-message" v-if="empDetails.SOCWageInformation.SOCCode != null && empDetails.SOCWageInformation.SOCCode != ''"
                                            :title="empDetails.SOCWageInformation.SOCCode">{{empDetails.SOCWageInformation.SOCCode}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </td>
                                    <td>
                                        <span class="headline">OES/SOC Title</span>
                                        <span class="headline-message" v-if='empDetails.SOCWageInformation.SOCTitle != null && empDetails.SOCWageInformation.SOCTitle != ""'
                                            :title="empDetails.SOCWageInformation.SOCTitle">{{empDetails.SOCWageInformation.SOCTitle}}</span>
                                        <span class="headline-message" v-else>N/A</span>
                                    </td>
                                </tr>

                            </table>
                        </div>

                        <!-- <link-flow-diagram v-if="!isRecruiter && empDetails && empDetails.LayerDetails" :link="empDetails.LayerDetails" :onTaxTermData="taxTermData"></link-flow-diagram> -->
                        <!-- As per businees requirement Link flow diagram is commented for this ST 45061 -->
                        <!-- <link-flow-diagram v-if="empDetails && empDetails.LayerDetails" :link="empDetails.LayerDetails" :onTaxTermData="taxTermData"></link-flow-diagram> -->
                        <!-- <div class="project-control-documents" v-else-if="empDetails.LayerDetails == null && empDetails.IsOnBoarded == true">
                            <h4>Your link to End-client <span v-tooltip="'Not all tiers could have been added, please edit and add if there is any additional tiers.'"><i class="fa fa-info-circle"></i></span></h4>
                             <a class="edit-link-client" @click="editClientLinkAdd(empDetails)">Add</a>
                       </div> -->



                    </div>
                </div>
                <template>
                    <!-- <div class="project-control-documents" v-if="checkCandidateDocument">
                        <div class="request-doc">
                            <h4>Candidate Documents</h4>
                            <div class="request-btn">
                                <ob-button type="primary" @click="requestDocuments('Candidate','request',false,'',empDetails.JobId, empDetails.OnBoardHireType,empDetails.JobName,consultantDetails.Email)"
                                    :disabled="!empDetails.JobId">Request Candidate Documents</ob-button>
                            </div>
                        </div>
                        <ob-projects-upload-document-group-ess groupName="CandidateDocument" :jobId="jobId" :consultantId="consultantId" :hireType="empDetails.OnBoardHireType"
                          v-if="refreshCandidateDocuments === true"></ob-projects-upload-document-group-ess>
                    </div> -->
                    <div class="project-control-documents" v-if="checkClientDocument">
                        <div class="request-doc">
                            <h4>Client Documents</h4>
                        </div>
                        <ob-projects-upload-document-group-ess groupName="ClientDocuments" :jobId="jobId" :consultantId="consultantId" :hireType="empDetails.OnBoardHireType"
                          v-if="refreshClientDocuments === true"></ob-projects-upload-document-group-ess>

                    </div>
                    <!-- <div class="project-control-documents" style="border-bottom:0;" v-if="checkVendorDocument">
                        <div class="request-doc">
                            <h4>{{vendorDocumentHeading}} Documents</h4>
                        </div>
                        <ob-projects-upload-document-group-ess groupName="VendorDocuments" :jobId="jobId" :consultantId="consultantId" :hireType="empDetails.OnBoardHireType" v-if="refreshVendorDocuments === true">></ob-projects-upload-document-group-ess>
                         <div class="current-project-btn" v-if="isHRManager && empDetails.IsParentJob">
                             <div class="current-project-btn" v-if="empDetails.IsParentJob">
                            <ob-button type="primary" size="lg" @click.native="confirmEndProjects(empDetails.JobId)">End Project</ob-button>
                        </div>
                    </div> -->
                </template>
            </template>
        </ob-folder>
        <view-Job-details :isViewDetailsshow.sync="ViewDetailsshow" :projectDetailsData.sync='cEmpDetails'></view-Job-details>
        <ob-modal2 :show.sync="openAlertDeleteProject" :type="1">
            <div class="modal-soc--body" style="padding:30px 15px;text-align:center">
                <img style="height:72px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/warning-red-alert.svg`" />
                <p style="font-size: 46px;font-weight: 100;">Alert</p>
                <h2> Are you sure you want to delete?</h2>
                <p style="padding-top: 15px;font-size:14px;">Deleting this project will remove all the project information from your records. <br>Please contact your HR before deleting.</p>
            </div>
            <div class="modal-soc--footer" style="padding: 0px 20px 20px 20px;text-align:center;">
                <ob-button type="secondary" @click="deleteProject(jobID)">Yes</ob-button>
                <ob-button @click="closeAlertPopup">No</ob-button>
            </div>
        </ob-modal2>
         <ob-modal2 :show.sync="openAlertLCALinkedProject" :type="1">
            <div class="modal-soc--body" style="padding:30px 15px;text-align:center">
                <img style="height:90px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/warning-red-alert.svg`" />
                <p style="font-size: 46px;font-weight: 100;">Alert</p>
                <p style="padding-top: 12px;font-size:15px;">This project cannot be deleted as it is already linked to an LCA. <br>Please contact your HR.</p>
            </div>
            <div class="modal-soc--footer" style="padding: 0px 20px 20px 20px;text-align:center;">
                <ob-button type="secondary" @click="closeLCAAlertPopup">Cancel</ob-button>
            </div>
        </ob-modal2>
    </div>
</template>
<script>
import LinkFlowDiagram from '../ESSProjects/EmpLinkFlowDiagram.vue'
import viewJobDetails from '../ESSProjects/viewJobDetailsPopUp.vue'
    export default {
        props: {
            empDetails: {
                type: Object,
                required: true
            },
            IsPreviousProject: {
                type: Boolean,
                default: false
            },
            expantMode:{
                default: false
            }
        },
         components: {
            'link-flow-diagram': LinkFlowDiagram,
            'view-Job-details': viewJobDetails
            // 'add-project-details': addProjectDetails

        },
        data() {
            return {
                cEmpDetails: null,
                ExpandFolder: true,
                refreshCandidateDocuments: true,
                refreshClientDocuments: true,
                refreshVendorDocuments: true,
                requestDocumentObject: {},
                isRequestDocumentPopupVisible: false,
                id: 1,
                idvendor: 1,
                updateFlag: false,
                isSending: false,
                ViewDetailsshow: false,
                taxTermData: '',
                options: {
                    data: [

                    ]
                },
                isOnboarded: true,
                clientActionList: [{
                    name: 'Request Document',
                    callback: (d) => {
                        this.requestSingleDocument(d, 'Client')
                    }
                }],
                candidateActionList: [{
                    name: 'Request Document',
                    callback: (d) => {
                        this.requestSingleDocument(d, 'Candidate')
                    }
                }],
                vendorActionList: [{
                    name: 'Request Document',
                    callback: (d) => {
                        this.requestSingleDocument(d, 'Vendor')
                    }
                }],

                candidateDocList: null,
                documentShow: {
                    "Recruiter": {
                        "Candidate": [],
                        "Vendor": ["C2C", "1099"],
                        "Client": []
                    },
                    "AccountManager": {
                        "Candidate": [],
                        "Vendor": ["C2C", "1099"],
                        "Client": ["W2", "C2C", "1099"]
                    },
                    "HRManager": {
                        "Candidate": [],
                        "Vendor": ["C2C", "1099"],
                        "Client": ["W2", "C2C", "1099"]
                    },
                },
                openAlertDeleteProject: false,
                jobID : "",
                openAlertLCALinkedProject:false
            }


        },

        watch: {

        },
        created() {
            this.cEmpDetails = __.cloneDeep(this.empDetails)
            this.$emit('OnboardTax' , this.cEmpDetails.OnBoardHireType )
            this.ExpandFolder = this.expantModee
            this.taxTermData = this.empDetails.OnBoardHireType
        },
        computed: {
            // isRecruiter() {
            //     return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.Recruiter
            // },
            //  isHRManager(){
            //     return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.HRManager
            // },
            // isAccountManager() {
            //     return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.AccountManager
            // },
            EndDateCount(){
              let a = moment(this.cEmpDetails.EndDate)
              let b =(moment(new Date()))
              let days = a.diff(b, 'days')
              return days
            },
            vendorDocumentHeading() {
                return this.empDetails.OnBoardHireType == "1099" ? "1099" : "Vendor"
            },
            options1() {

                if (this.IsPreviousProject === true) {
                    return {
                        format: 'MM/DD/YYYY',
                        widgetPositioning: {
                            horizontal: 'right',
                            vertical: 'bottom'
                        }
                    }
                } else {
                    return {
                        format: 'MM/DD/YYYY',
                        minDate: moment().subtract(1, 'days'),
                        widgetPositioning: {
                            horizontal: 'right',
                            vertical: 'bottom'
                        }
                    }
                }
            },
            options2() {
                return {
                    format: 'MM/DD/YYYY',
                    minDate: this.empDetails.StartDate,
                    widgetPositioning: {
                        horizontal: 'right',
                        vertical: 'bottom'
                    }
                }
            },
            dataClient() {
                if (this.empDetails && this.empDetails.LayerDetails) {
                    let VendorDetails = []
                    let ClientDetails = [];

                    this.empDetails.LayerDetails.forEach((e) => {
                        if (e.Type == 'Self') {
                            let addvendordateai = {
                                idvendor: this.idvendor,
                                isDelete: false,
                                isAddVendor: true,
                                isDisabledVendor: true,
                                Types: e.Type,
                                OrganizationName: e.OrganizationName,
                                OrganizationWebsite: e.Website
                            }
                            VendorDetails.push(addvendordateai)

                        }
                        else if (e.Type == 'Vendor') {
                            let addvendordateai = {
                                idvendor: this.idvendor,
                                isDelete: false,
                                isAddVendor: true,
                                isDisabledVendor: true,
                                Types: e.Type,
                                OrganizationName: e.OrganizationName,
                                OrganizationWebsite: e.Website
                            }
                            VendorDetails.push(addvendordateai)

                        }
                        else {

                            let vendatdata = {
                                id: '',
                                isAddAnotherClient: true,
                                isDelete: false,
                                isDisabledClient: true,
                                Types: e.Type,
                                EndClientName: e.OrganizationName,
                                EndClientWebsite: e.Website
                            }

                            ClientDetails.push(vendatdata)


                        }


                    })
                    return {
                        VendorDetails: VendorDetails,
                        ClientDetails: ClientDetails
                    }
                }

                return null
            },
            accessFlag() {
                if (this.empDetails && this.empDetails.IsParentJob == true)
                    return false

                else
                   return true

                // if (this.isHRManager)
                //     return false
                // else if (this.empDetails && this.empDetails.IsParentJob == true)
                //     return false
                // else
                //     return true
            },
            checkHireType() {
                if (this.empDetails.OnBoardHireType == 'W2')
                        return false
                    else
                        return true

                // if (this.isHRManager) {
                //     if (this.empDetails.OnBoardHireType == 'W2')
                //         return false
                //     else
                //         return true
                // } else {
                //     return true
                // }
            },
            checkClientDocument() {
                // if (this.loggedInUserObj.Role == this.loggedInUserObj.Roles.Recruiter) {
                    /*if (this.documentShow.Recruiter.Client.indexOf(this.empDetails.OnBoardHireType) != -1) {
                        return true
                    } else {
                        return false
                    }
                // } else if (this.loggedInUserObj.Role == this.loggedInUserObj.Roles.AccountManager) {
                    if (this.documentShow.AccountManager.Client.indexOf(this.empDetails.OnBoardHireType) != -1) {
                        return true
                    } else {
                        return false
                    }
                // } else if (this.loggedInUserObj.Role == this.loggedInUserObj.Roles.HRManager) {
                    if (this.documentShow.HRManager.Client.indexOf(this.empDetails.OnBoardHireType) != -1) {
                        return true
                    } else {
                        return false
                    }*/

                // }
                return true

            },
            checkCandidateDocument() {
                // if (this.loggedInUserObj.Role == this.loggedInUserObj.Roles.Recruiter) {
                    if (this.documentShow.Recruiter.Candidate.indexOf(this.empDetails.OnBoardHireType) != -1) {
                        return true
                    } else {
                        return false
                    }
                // } else if (this.loggedInUserObj.Role == this.loggedInUserObj.Roles.AccountManager) {
                    if (this.documentShow.AccountManager.Candidate.indexOf(this.empDetails.OnBoardHireType) != -1) {
                        return true
                    } else {
                        return false
                    }
                // } else if (this.loggedInUserObj.Role == this.loggedInUserObj.Roles.HRManager) {
                    if (this.documentShow.HRManager.Candidate.indexOf(this.empDetails.OnBoardHireType) != -1) {
                        return true
                    } else {
                        return false
                    }
                // }
            },
            checkVendorDocument() {
                // if (this.loggedInUserObj.Role == this.loggedInUserObj.Roles.Recruiter) {
                    if (this.documentShow.Recruiter.Vendor.indexOf(this.empDetails.OnBoardHireType) != -1) {
                        return true
                    } else {
                        return false
                    }
                // } else if (this.loggedInUserObj.Role == this.loggedInUserObj.Roles.AccountManager) {
                    if (this.documentShow.AccountManager.Vendor.indexOf(this.empDetails.OnBoardHireType) != -1) {
                        return true
                    } else {
                        return false
                    }
                // } else if (this.loggedInUserObj.Role == this.loggedInUserObj.Roles.HRManager) {
                    if (this.documentShow.HRManager.Vendor.indexOf(this.empDetails.OnBoardHireType) != -1) {
                        return true
                    } else {
                        return false
                    }
                // }
            },
            consultantId() {
               // return  "5bc48f5ad864c70218c8ccd2"
                 return loggedInUserObj.consultantId
            },
            jobId() {
                return this.empDetails.JobId
            },
            candidateDocSignatureList() {
                return this.empDetails.candidateDocSignatureList || []
            },
            candidateObject() {
                return this.empDetails.candidateObject || []
            },
            vendorDocList() {
                return this.empDetails.vendorDocList
            },
            vendorDocSignatureList() {
                return this.empDetails.vendorDocSignatureList || []
            },
            vendorObject() {
                return this.empDetails.vendorObject || []
            },
            clientDocList() {
                return this.empDetails.clientDocList
            },
            clientDocSignatureList() {
                return this.empDetails.clientDocSignatureList || []
            },
            clientObject() {
                return this.empDetails.clientObject || []
            },
            LCADocList() {
                return this.empDetails.LCADocList
            },
            LCADocListl() {
                return this.empDetails.LCADocListl
            },
            fileUploadUrl() {
                // ${this.$route.params.id}
                return `/OnBoard/UpdateDocumentByGroup?consultantId=${loggedInUserObj.consultantId}&jobId=${this.empDetails.JobId}&orgId=${loggedInUserObj.orgId}`
            },
            candidateFileUploadUrl() {
                return `/Compliance/UpdateRequestedDocumentByCandidate?requestedTo=vinujs@getnada.com&requestedBy=59253b6625f57f27a46e2382&requestTo=Candidate`
            },
            vendorFileUploadUrl() {
                return `/Compliance/UpdateRequestedDocumentByCandidate?requestedTo=vinujs@getnada.com&requestedBy=59253b6625f57f27a46e2382&requestTo=Vendor`
            },
            clientFileUploadUrl() {
                return `/Compliance/UpdateRequestedDocumentByCandidate?requestedTo=vinujs@getnada.com&requestedBy=59253b6625f57f27a46e2382&requestTo=Client`
            },
            consultantDetails() {
                return this.$store.getters.getConsultantDetails
            },
            h1BFind() {
                if (this.empDetails && this.empDetails.HireType.includes("H-1B")) {
                    return true
                }
                else {
                    return false
                }
            }

        },
        validations() {
            return {
                empDetails: {

                    "StartDate": {
                        required
                    },
                    "EndDate": {
                        required
                    },
                    "Duration": {
                        required,
                        maxLength: maxLength(4)
                    },
                    "PayRate": {
                        required
                    }

                }
            }
        },
        methods: {
           getWorkLocation(Work)
            {
                var loc = '';
                if(Work.Address1 != null && Work.Address1 !='')
                {
                   loc += Work.Address1+", "
                }
                 if(Work.Address2 != null && Work.Address2 !='')
                {
                   loc += Work.Address2+", "
                }
                 if(Work.Location !='')
                {
                   loc += Work.Location+", "
                }
                 if(Work.Zipcode !='')
                {
                   loc += Work.Zipcode
                }
                return loc;
            },  
          getTimeSheetCycleName(Name){
            if(Name == 'BiWeekly'){
              return 'Bi-Weekly'
            }else if(Name == 'SemiMonthly'){
              return 'Semi-Monthly'
            }
            else{
              return Name
            }
          },
          getDateFormat(date){
            if(date == 1 || date == 21){
              return date+'st'
            }
            else if(date == 2 || date == 22){
              return date+'nd'
            }
            else if(date == 3 || date == 23){
              return date+'rd'
            }
            else{
              return date+'th'
            }
          },
          EndDateCountFormate(EndDate){
              var projectDate = EndDate
              var currentDate = moment()
              var years = moment(projectDate).diff(currentDate, 'year');
                currentDate.add(years, 'years');

              var months = moment(projectDate).diff(currentDate, 'months');
                currentDate.add(months, 'months');

              var weeks = moment(projectDate).diff(currentDate, 'weeks');
                currentDate.add(weeks, 'weeks');

              var days = moment(projectDate).diff(currentDate, 'days');

              var sameday = moment(projectDate).isSame(currentDate, 'days');

              var str = '';

              if(years > 0)
              {
                str += years + (years > 1 ? ' Years ' : ' Year ')
              }
              if(months > 0)
              {
                str += months + (months > 1 ? ' Months ' : ' Month ')
              }
              if(weeks > 0)
              {
                str += weeks + (weeks > 1 ? ' Weeks ' : ' Week ')
              }
              if(days > 0)
              {
                str += days + (days > 1 ? ' Days ' : ' Day ')
              }
              if(sameday){
                str += '0 days'
              }
              return str
            },
            // isEmpdetailsupdated(){
            //     this.updateFlag = false
            //     this.$emit('isEmpdetailprojects')
            // },
            // onCancel() {
            //     this.cEmpDetails.updateFlag = false; this.empDetails = __.cloneDeep(this.cEmpDetails)
            // },
            viewJobDetailsShow() {
                this.ViewDetailsshow = true
            },
            onRequestDocumentPopupClose(request) {
                if (request.requestFor.toLowerCase() == "candidate") {
                    this.refreshCandidateDocuments = false
                    setTimeout(() => {
                        this.refreshCandidateDocuments = true
                    }, 500)
                } else if (request.requestFor.toLowerCase() == "vendor") {
                    this.refreshVendorDocuments = false
                    setTimeout(() => {
                        this.refreshVendorDocuments = true
                    }, 500)
                } else if (request.requestFor.toLowerCase() == "client") {
                    this.refreshClientDocuments = false
                    setTimeout(() => {
                        this.refreshClientDocuments = true
                    }, 500)
                }
            },

            // editProjectInfo(id) {
            //     this.ExpandFolder = true
            //     this.empDetails.updateFlag = true
            // },
            // updateProjectInfo(jobId) {
            //     this.$v.empDetails.$touch();
            //     if (this.$v.empDetails.$invalid == false) {
            //         this.$loading({ "loadingText": "Updating project details..." })
            //         let valuesObj = {
            //             "Id": this.$route.params.id,
            //             "JobId": jobId,
            //             "EmployeeId": this.$route.params.id,
            //             "StartDate": this.empDetails.StartDate,
            //             "EndDate": this.empDetails.EndDate,
            //             "Duration": this.empDetails.Duration,
            //             "PayRate": this.empDetails.PayRate

            //         }
            //         this.isSending = true
            //         ajax.put(`/Employee/UpdateEmployeeProjectInfo`, valuesObj, (res) => {
            //             this.$loading({}).close()
            //             if (res.data.State == true) {
            //                 this.updateFlag = false
            //                 this.isSending = false
            //                 this.$message({
            //                     type: 'success',
            //                     message: 'Employee project details updated successfully'
            //                 })
            //                 events.fire('emp-details-updated')
            //             } else {
            //                 this.isSending = false
            //             }
            //         })
            //     }
            //     //    }
            //     //})

            // },
            requestDocuments(requestFor, requestType, isSingle, RequestedDocumentId, jobId, hireType, jobName, email) {
                let obj = {
                    requestFor: requestFor,
                    requestType: requestType,
                    isSingle: isSingle,
                    RequestedDocumentId: RequestedDocumentId,
                    // consultantId: this.$route.params.id,
                    consultantId:"5bc48f5ad864c70218c8ccd2",

                    jobId: jobId,
                    hireType: hireType,
                    jobName: jobName,
                    email: email
                }
                //events.fire('request-document-popup', obj);

                this.requestDocumentObject = obj
                this.isRequestDocumentPopupVisible = true
            },
            requestSingleDocument(d, requestFor) {
                let obj = {
                    requestFor: requestFor,
                    requestType: 'request',
                    isSingle: true,
                    RequestedDocumentId: d.DocumentId,
                    // id: this.$route.params.id,
                    id:"5bc48f5ad864c70218c8ccd2",
                    jobId: this.empDetails.JobId
                }

                events.fire('request-document-popup', obj);
            },
            initiateDocument(p) {
                this.$loading({ 'loadingText': 'Initializing...' })
                ajax.get(`Compliance/InitiateRequestedDocument?placementId=${p.PlacementId}`, {}, (res) => {
                    if (res.data.State == true) {
                        this.$loading({}).close()
                        events.fire('emp-details-updated')
                    }
                    else if (res.data.State == false) {
                        //this.ESSEnableDisable(res)
                        this.$message({
                            type: 'error',
                            message: res.data.Message
                        })
                    }
                })
                this.$loading({}).close()
            },
            confirmEndProjects(jobId) {
                if (this.empDetails.IsCloseProject == true) {
                    events.fire('cancel-projects-popup', jobId)
                } else {
                    events.fire('confirm-end-projects-popup', jobId)
                }
            },

            editProjectInfo(id) {
                setTimeout(()=>{
                    this.$router.push({path:'/add-new-project',query:{projectid:id,consultantid:loggedInUserObj.consultantid}});
                },1000)
            },

            alertDeleteProject(val, isLinkedLCA){
                if(isLinkedLCA){
                    this.openAlertLCALinkedProject = true
                }else{
                    this.jobID = val
                    this.openAlertDeleteProject = true
                }
            },
            closeAlertPopup(){
                this.jobID = ""
                this.openAlertDeleteProject = false
            },
            closeLCAAlertPopup(){
                this.openAlertLCALinkedProject = false
            },
            deleteProject(val){
            this.$loading({'loadingText':'Deleting project...'})
            ajax.post(`/Projects/DeleteProject?jobId=${val}&isEmployeeDeletingProject=true&employeeOrgId=${loggedInUserObj.orgId}`,{},(res) => {
                    this.$loading({}).close()
                    if(res.data.State == true){
                        this.$message({
                            type: 'success',
                            message: res.data.Message
                        })
                        events.fire('emp-details-updated')
                        events.fire('leftSection')
                    }
                    else {
                        this.$loading({}).close()
                        this.$message({
                            type: 'error',
                            message: res.data.Message
                        })

                    }
                })
        },

            //updateDocument(index, document) {
            //    Vue.set(this.LCADocListl, index, document)
            //},
            // updateDocument1(index, document) {
            //     Vue.set(this.candidateDocList, index, document)
            // },
            // updateDocument2(index, document) {
            //     Vue.set(this.clientDocList, index, document)
            // },
            // updateDocument3(index, document) {
            //     Vue.set(this.vendorDocList, index, document)
            // },

            // updateEnd(startDate) {
            //     this.empDetails.StartDate = startDate
            //     this.getEndDate()
            //     //let strtMonth = moment(this.empDetails.EndDate).diff(this.empDetails.StartDate, "months");

            //     /*this.empDetails.Duration = strtMonth

            //     var a = moment(this.empDetails.StartDate);
            //     var b = moment(this.empDetails.EndDate);
            //     a.diff(b, 'months')
            //     this.empDetails.Duration = a*/
            // },
            // getEndDate() {

            //     let formatDate = moment(this.empDetails.StartDate).add(this.empDetails.Duration, 'months').format('MM/DD/YYYY');
            //     if (formatDate == "Invalid date") {
            //         this.empDetails.EndDate = moment(this.empDetails.StartDate, 'MM/DD/YYYY').add(this.empDetails.Duration, 'months').format('MM/DD/YYYY');
            //     } else {
            //         this.empDetails.EndDate = moment(this.empDetails.StartDate).add(this.empDetails.Duration, 'months').format('MM/DD/YYYY');
            //     }

            //     // ajax.get(`/GetEndDate?startDate=${this.empDetails.StartDate}&duration=${this.empDetails.Duration}`,{},(res) =>{
            //     //     this.empDetails.EndDate = res.data.EndDate;
            //     // })
            // },
            // editClientLink() {
            //     this.$emit('linkToEndClientPopupOpen', this.empDetails.LayerDetails)
            // },
            // editClientLinkAdd(r) {
            //     this.$emit('linkToEndClientPopupOpenAdd')
            // },
            // viewJobDetailsShow() {
            //     this.ViewDetailsshow = true
            // },
            // CancelEditproject() {
            //     this.onCancel()
            // }

        }

    }
</script>
<style lang="scss">
    .view-job_details{
    float: right;
    color: #4A90E2;
    font-weight: 600;

}
.view-job_details a:hover{
    color: #4A90E2;
    font-weight: 600;
}
 .folder-header-heading {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 450px;
    }
     .projects-container{
        .project-control-documents{
            border-bottom: 2px dashed #c2c2c2;
             padding: 20px 0;
        }
      }
    .project-control-documents .col-md-3 {
        margin-bottom: 10px;
        padding-left:0;
    }

    .project-control-documents.editing .headline-message {
        overflow: visible;
    }

    .project-control-documents.editing input[readonly] {
        background-color: #eeeeee !important;
    }
    *,
    *::before,
    *::after {
    margin: 0px;
    padding: 0px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
#project_clientDetails{
  .ul{
    margin:10px;
    .li{
         width: 110px;
    height: 48px;
    position: relative;
    list-style-type: none;
    padding: 7px 10px 10px 12px;
    border: 2px solid #979797;
    border-radius: 5%;
    float: left;
    margin-left: 30px;
    margin-bottom: 25px;
      .website_txt{
                font-size: 10px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
      }
      .website_org{
            color: #143361;
            font-size: 12px;
            font-weight: 600;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
      }
      &:after{
        content: '';
        background: #979797;
        position: absolute;
        top: 24px;
        width: 32px;
        height: 2px;
        margin-left:94px;
      }
       &:last-child:after{
          width: 0px !important;
        }
        &:last-child{
         .left {
           display:none;
         }
        }
        &:first-child{
         margin-left:0;
        }
           i {
  border: solid #979797;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;

}

.right {
        position: absolute;
    left: -13px;
    top: 21px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
}

.left {
    position: absolute;
    right: 0;
    margin-right: -11px;
    top: 21px;
    z-index: 1;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
      }
    }

  }
}
.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

#project_clientDetails .ul .Vendor-org i.left{
           display:none;
         }
         .edit-link-client{
            float: right;
            margin-right: 17px;
            font-weight: 600;
            font-size: 13px;
            font-style: italic;
         }

</style>
<style scoped>
.worklocation-txt .headline-message{
        display: inline-block !important;
        max-width: 200px;
}
.details-show-con{
    padding: 10px 0 10px 0;
}
.projects-days{
    font-weight: 900;
    color: #36393f;
}
.work-location-header{
        display: block !important;

}
.work-location-data{
    display: inline-block !important;
}
.work-force-con{
    border: 0;
    border-top: 2px dashed #c2c2c2;
    padding-bottom: 20px;
}
.details-bottom{
    padding-bottom: 20px;
}
.Work-auth-tax{
    display: inline-block;
    border-radius: 17px;
    border: 1px solid #4A90E2;
    padding: 5px 10px;
    background: #4A90E2;
    margin-left: 10px;
    max-width: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: #fff;
    transform: translateY(1px);
    font-size: 11px;
}
.header-text{
    max-width: 330px;
    width: auto !important;
    display: inline-block;
}
 .proj-location{
        font-weight: 600;
    color: #143361;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: block;
    margin-bottom: 10px;
    }
    .sub-heading{
        font-weight: 600;
        margin-top:10px;
        color: #4A90E2;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ESSProjects/EmpProjectsDocuments.vue